import React from 'react';
import { Card, Skeleton } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

const TruckTurnaroundCard = ({ data, loading }) => {
  console.log('turnaround', data);

  const totalTrucks = data[0]?.trucks_unloaded;
  const trucks = data[0]?.trucks || [];
  const dockUtilization = data[0]?.trucks;
  console.log('unloaded', totalTrucks, dockUtilization);

  const idleSum = trucks?.reduce((sum, truck) => sum + truck.unloading_tat, 0);

  const formatTime = (time) => {
    if (isNaN(time) || time <= 0) return '0 Mins';
    const hours = Math.floor(time / 60);
    const minutes = time % 60;
    return hours > 0 ? `${hours} Hrs ${minutes} Mins` : `${minutes} Mins`;
  };

  const formattedIdleSum = formatTime(idleSum);

  const StatItem = ({ label, counts, loading }) => {
    return (
      <div className="bg-white rounded p-3 mb-2">
        {loading ? (
          <>
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="text" width="40%" height={20} />
          </>
        ) : (
          <div className="flex flex-col">
            <div className="flex items-baseline gap-1">
              <span className="text-xl font-medium">{counts}</span>
            </div>
            <div className="text-sm text-gray-500">{label}</div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <Card
        className="border relative border-gray-300"
        sx={{
          height: '276px',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px'
        }}
      >
        <div className="flex w-full flex-col gap-1 p-3">
          <div className="flex items-center gap-2">
            <LocalShippingIcon className="text-white rounded-full p-2 text-6xl" style={{ backgroundColor: '#2196f3' }} />
            <div style={{ width: loading ? '120px' : 'auto' }}>
              {loading ? (
                <>
                  <Skeleton variant="text" width="100%" height={40} />
                  <Skeleton variant="text" width="80%" height={28} />
                </>
              ) : (
                <>
                  <div className="flex items-baseline">
                    <span className="text-3xl font-medium">{totalTrucks}</span>
                    <span className="text-sm text-gray-500 ml-1">Total Trucks</span>
                  </div>
                  <p className="text-lg font-semibold">
                    Dock Utilization
                    <span className="text-sm font-normal text-gray-500 ml-2">
                      (<span>{formattedIdleSum}</span>)
                    </span>
                  </p>
                </>
              )}
            </div>
          </div>

          <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
            <div className="text-xs text-gray-500 mb-2 italic">More Statistics</div>

            {trucks.map((items, id) => (
              <StatItem
                key={id}
                label={
                  <>
                    <span className="text-xl font-bold text-black">Truck {id + 1}</span>
                    <hr />
                    <div className="flex items-center justify-between mt-2">
                      {/* Unloading TAT Section */}
                      <div className="text-center">
                        <span className="text-l font-semibold text-black">{formatTime(items.unloading_tat)}</span>
                        <span className="block text-xs font-medium text-gray-500">Unloading TAT</span>
                      </div>

                      {/* Idle Minutes Section */}
                      <div className="text-center mr-5">
                        <span className="text-l font-semibold text-black">{formatTime(items.idle_time)}</span>
                        <span className="block text-xs font-medium text-gray-500">Idle Minutes</span>
                      </div>
                    </div>
                  </>
                }
              />
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default TruckTurnaroundCard;
